import type { OnboardingSessionConfig } from '@onefootprint/request-types';
import { cx } from 'class-variance-authority';
import { forwardRef } from 'react';
import { FOOTPRINT_FOOTER_ID } from '../../../constants';
import SecuredByFootprint from '../../secured-by-footprint';
import FooterActions from './footer-actions';

type MobileFooterProps = {
  ref: React.RefObject<HTMLDivElement | null>;
  footerVisible: boolean;
  config?: OnboardingSessionConfig;
  defaultOpen?: boolean;
  footerPosition: 'sticky' | 'relative';
  hideOnDesktop?: boolean;
};
const MobileFooter = forwardRef<HTMLDivElement, MobileFooterProps>(
  ({ footerVisible, config, defaultOpen, footerPosition, hideOnDesktop }, ref) => {
    return (
      <footer
        id={FOOTPRINT_FOOTER_ID}
        ref={ref}
        className={cx('flex justify-between py-3 px-4 border-t border-tertiary bg-secondary w-full', {
          'sticky bottom-0 z-5': footerPosition === 'sticky',
          'relative z-1!': footerPosition !== 'sticky',
          'hidden!': !footerVisible,
          'min-[900px]:hidden!': hideOnDesktop,
        })}
      >
        <SecuredByFootprint />
        <FooterActions config={config} defaultOpen={defaultOpen} />
      </footer>
    );
  },
);

export default MobileFooter;
